import { AbstractModel } from '../../shared/abstract.model';
import { LandingPageTile } from '../../shared/tiles/home-tile.model';

export class LandingPageConfig extends AbstractModel {
  name: string;
  tiles: Array<LandingPageTile>;
}
